const STORAGE_KEY = "quickBidDraft";

export function saveQuickBidDraft(state) {
  if (!state || typeof state !== "object") return;
  const draft = {
    makeId: state.makeId,
    seriesId: state.seriesId,
    carId: state.carId,
    car: state.car,
    colorId: state.colorId,
    optionIds: Array.isArray(state.optionIds) ? [...state.optionIds] : [],
    targetPrice: state.targetPrice,
    discountPercentage: state.discountPercentage,
    deliveryFee: state.deliveryFee,
    step: state.step,
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
  } catch (e) {
    // Ignore quota / private-mode failures; guest can rebuild.
  }
}

export function loadQuickBidDraft() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const draft = JSON.parse(raw);
    return draft && typeof draft === "object" ? draft : null;
  } catch (e) {
    return null;
  }
}

export function clearQuickBidDraft() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // no-op
  }
}
